/**
 * デプロイで消えた chunk を、古い画面が読みにいったときの判定と、
 * 公開面の自動復旧を同一タブで1回に限るためのフラグ。
 *
 * 起動時の pending → spent の確定は index.html のインラインスクリプトだけが行う。
 * ここでもう一度確定すると、自動復旧の直後に spent が消える。
 * キー名を変えるときは index.html も合わせること。
 */

export const CHUNK_RELOAD_PENDING_KEY = 'notreu:chunkReloadPending';
export const CHUNK_RELOAD_SPENT_KEY = 'notreu:chunkReloadSpent';

/** 非公開面で chunk が取れなかったとき、UpdateBanner が強い案内に切り替える。 */
export const UPDATE_REQUIRED_EVENT = 'notreu:updateRequired';

export function isDeployChunkError(error: unknown): boolean {
  if (!(error instanceof Error)) return false;
  const message = error.message;
  return (
    message.includes('Failed to fetch dynamically imported module') ||
    message.includes('Failed to load module script') ||
    message.includes('Loading chunk') ||
    message.includes('Loading CSS chunk') ||
    message.includes("Unexpected token '<'") ||
    message.includes('Unexpected token "<"')
  );
}

export function isChunkReloadSpent(): boolean {
  try {
    return sessionStorage.getItem(CHUNK_RELOAD_SPENT_KEY) === '1';
  } catch {
    return true;
  }
}

/** 自動復旧の直前に pending を立てる。書けなければ reload しない（無限ループ防止）。 */
export function beginChunkReload(): boolean {
  try {
    if (sessionStorage.getItem(CHUNK_RELOAD_SPENT_KEY) === '1') return false;
    sessionStorage.setItem(CHUNK_RELOAD_PENDING_KEY, '1');
    return true;
  } catch {
    return false;
  }
}
